export default "__VITE_ASSET__BowAX1lO__"